<template>
   <!-- Login section begin -->
  <!--
  <div class="container">
    <div class="row justify-content-center">
        <div class="col-md-10">
           <div class="card">-->

    <div class="login">
        <div class="login-header">
          <h3>Member Login</h3>
        </div>
        <div class="login-form">
          <h5>Email:</h5>
          <input type="text" v-model="email" placeholder="Email"/><br>
          <h5>Password:</h5>
          <input type="password" v-model="password" placeholder="Password"/>
          <br>
          <input type="button" value="Login" class="login-button" @click='login'/>
          <!--<br>
          <input type="button" value="testing" class="login-button" @click='testing'/>-->
          <br>
          <a href="#" >
              <span><router-link to="/signup" class="sign-up">Sign Up!</router-link></span>
          </a>
          <br>
          <!--<h6 class="no-access">Can't access your account?</h6>-->
        </div>
        <!--
        <div class="error-page">
        <div class="try-again">Error: Try again?</div>
      </div>-->
    </div>

 </template> 

 <script>
    import firebase from 'firebase'

    export default {
        name: 'login',
        data: function() {
          return {
            email: '',
            password: ''
          }
        },
        methods: {
          login: function(){
            //alert('Email: ' + this.email + '; Passwor: ' + this.password)
            /*THIS IS SIGN IN WITHOUT EMAIL VERIFICATION*/

             firebase.auth().signInWithEmailAndPassword(this.email, this.password).then ( user => {
                    //17-Dec, set vuex state
                    this.$store.commit('isUserSignedUp', true);
                    this.$store.commit('isUserLoggedIn', true);
                    this.$store.commit('setUserName', this.email);
                    //alert ('Login User: ' + this.$store.getters.getUserName);
                    alert('Welcome ' + this.$store.getters.getUserName + '!, You are sign-in successfully!');
                    this.$router.replace('home');
             }).catch(err => {
                alert('Oops, ' + err.message)
             })

 /* auth only but can't touch vuex state              
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then (
                function(user) {
                     alert('Welcome !, You are sign-in successfully!');                   
                  },
                  function(err){
                    alert('Oops, ' + err.message)
                  }
                );             
*/

            /*THIS IS SIGN IN WITH EMAIL VERIFICATION, IT IS ROUTED FROM USER'S MAIL */
/*****************************************************************************
             // Confirm the link is a sign-in with email link.
            if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
              // Additional state parameters can also be passed via URL.
              // This can be used to continue the user's intended action before triggering
              // the sign-in operation.
              // Get the email if available. This should be available if the user completes
              // the flow on the same device where they started it.
              var email = window.localStorage.getItem('emailForSignIn');
              if (!email) {
                // User opened the link on a different device. To prevent session fixation
                // attacks, ask the user to provide the associated email again. For example:
                email = window.prompt('Please provide your email for confirmation');
              }
              // The client SDK will parse the code from the link for you.
              firebase.auth().signInWithEmailLink(email, window.location.href)
                .then(function(result) {
                  // Clear email from storage.
                  window.localStorage.removeItem('emailForSignIn');
                  // You can access the new user via result.user
                  // Additional user info profile not available via:
                  // result.additionalUserInfo.profile == null
                  // You can check if the user is new or existing:
                  // result.additionalUserInfo.isNewUser
                })
                .catch(function(error) {
                  // Some error occurred, you can inspect the code: error.code
                  // Common errors could be invalid email and invalid or expired OTPs.
                });
            }
            **************************************************************************************/


          }
        }
    }
 </script>

<style scoped>
    body {
      background:url('http://cdn.wallpapersafari.com/13/6/Mpsg2b.jpg');
      margin:0px;
      font-family: 'Ubuntu', sans-serif;
      background-size: 100% 110%;
    }
    h1, h2, h3, h4, h5, h6, a {
      margin:0; padding:0;
    }
    .login {
      margin:0 auto;
      max-width:500px;
    }
    .login-header {
      color:#fff;
      text-align:center;
      font-size:300%;
    }
    /* .login-header h1 {
      text-shadow: 0px 5px 15px #000; */
    
    .login-form {
      border:.5px solid #fff;
      background:#4facff;
      border-radius:10px;
      box-shadow:0px 0px 10px #000;
    }
    .login-form h3 {
      text-align:left;
      margin-left:40px;
      color:#fff;
    }
    .login-form {
      box-sizing:border-box;
      padding-top:15px;
      padding-bottom:10%;
      margin:5% auto;
      text-align:center;
    }
    .login input[type="text"],
    .login input[type="password"] {
      max-width:400px;
      width: 80%;
      line-height:3em;
      font-family: 'Ubuntu', sans-serif;
      margin:1em 2em;
      border-radius:5px;
      border:2px solid #f2f2f2;
      outline:none;
      padding-left:10px;
    }
    .login-form input[type="button"] {
      height:30px;
      width:100px;
      background:#fff;
      border:1px solid #f2f2f2;
      border-radius:20px;
      color: slategrey;
      text-transform:uppercase;
      font-family: 'Ubuntu', sans-serif;
      cursor:pointer;
    }
    .sign-up{
      color:#f2f2f2;
      margin-left:-70%;
      cursor:pointer;
      text-decoration:underline;
    }
    .no-access {
      color:#E86850;
      margin:20px 0px 20px -57%;
      text-decoration:underline;
      cursor:pointer;
    }
    .try-again {
      color:#f2f2f2;
      text-decoration:underline;
      cursor:pointer;
    }

    /*Media Querie*/
    @media only screen and (min-width : 150px) and (max-width : 530px){
      .login-form h3 {
        text-align:center;
        margin:0;
      }
      .sign-up, .no-access {
        margin:10px 0;
      }
      .login-button {
        margin-bottom:10px;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/login.vue